import {normalize, schema} from "normalizr";
import { exists } from '../../util/util';
import moment from "moment/moment";

class LogConverter {
  
  fromAPILogsResponse(logsResp) {
    
    const localLog = logsResp.map(log => {
      return this.fromAPILog(log);
    });
    
    const logsEntity = new schema.Entity('logs');
    const logSchema = [logsEntity];
    const normalizedData = normalize(localLog, logSchema);
    
    console.info('[LogConverter.fromAPILog] converted logs: ', normalizedData.entities.logs);
    
    return normalizedData.entities.logs;
  }  
  
  
  fromAPILog(response) {
    
    let params = {};
    params.id = response.id;
  
    if(response.time) {
      params.time = response.time;
      
      params.hour = moment(response.time).hour();
      params.minutes = moment(response.time).minutes();
    }
    
    if(response.drynessStatus) {
      params.drynessStatus = response.drynessStatus;
    
      if(exists(response.drynessStatus.id)) params.drynessStatusId = response.drynessStatus.id;
      if(response.drynessStatus.title) params.drynessStatusTitle = response.drynessStatus.title;
    }
  
    if(response.presenceStatus) {
      params.presenceStatus = response.presenceStatus;
    
      if(exists(response.presenceStatus.id)) params.presenceStatusId = response.presenceStatus.id;
      if(response.presenceStatus.title) params.presenceStatusTitle = response.presenceStatus.title;
    }
    
    if(response.device) {
      params.device = response.device;
      if(exists(response.device.id)) params.deviceId = response.device.id;
    }
    
    return params;
  }
  
}

export default new LogConverter();


// WEBPACK FOOTER //
// ./src/models/logs/logConverter.js